import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule), canActivate: [AuthGuard]
  },
  {
    path: 'start',
    loadChildren: () => import('./pages/start/start.module').then(m => m.StartPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/account/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/account/signup/signup.module').then(m => m.SignupPageModule)
  },
  {
    path: 'service',
    loadChildren: () => import('./pages/terms/service/service.module').then(m => m.ServicePageModule)
  },
  {
    path: 'visiting',
    loadChildren: () => import('./pages/visiting/visiting.module').then(m => m.VisitingPageModule)
  },
  {
    path: 'visiting-order',
    loadChildren: () => import('./pages/visiting-order/visiting-order.module').then(m => m.VisitingOrderPageModule)
  },
  {
    path: 'video-order',
    loadChildren: () => import('./pages/video-order/video-order.module').then(m => m.VideoOrderPageModule)
  },
  {
    path: 'video',
    loadChildren: () => import('./pages/video/video.module').then(m => m.VideoPageModule)
  },
  {
    path: 'payment-point',
    loadChildren: () => import('./pages/payment-point/payment-point.module').then(m => m.PaymentPointPageModule)
  },
  {
    path: 'payment',
    loadChildren: () => import('./pages/payment/payment.module').then(m => m.PaymentPageModule)
  },
  {
    path: 'arranged',
    loadChildren: () => import('./pages/arranged/arranged.module').then(m => m.ArrangedPageModule)
  },
  {
    path: 'arranged-detail',
    loadChildren: () => import('./pages/arranged-detail/arranged-detail.module').then(m => m.ArrangedDetailPageModule)
  },
  {
    path: 'arranged-register',
    loadChildren: () => import('./pages/arranged-register/arranged-register.module').then(m => m.ArrangedRegisterPageModule)
  },
  {
    path: 'wanted',
    loadChildren: () => import('./pages/wanted/wanted.module').then(m => m.WantedPageModule)
  },
  {
    path: 'wanted-detail',
    loadChildren: () => import('./pages/wanted-detail/wanted-detail.module').then(m => m.WantedDetailPageModule)
  },
  {
    path: 'wanted-register',
    loadChildren: () => import('./pages/wanted-register/wanted-register.module').then(m => m.WantedRegisterPageModule)
  },
  {
    path: 'cominfo',
    loadChildren: () => import('./pages/cominfo/cominfo.module').then(m => m.CominfoPageModule)
  },
  {
    path: 'cominfo-modify',
    loadChildren: () => import('./pages/cominfo-modify/cominfo-modify.module').then(m => m.CominfoModifyPageModule)
  },
  {
    path: 'order',
    loadChildren: () => import('./pages/order/order.module').then(m => m.OrderPageModule)
  },
  {
    path: 'chat-list',
    loadChildren: () => import('./pages/chat-list/chat-list.module').then(m => m.ChatListPageModule)
  },
  {
    path: 'chat-detail',
    loadChildren: () => import('./pages/chat-detail/chat-detail.module').then(m => m.ChatDetailPageModule)
  },
  {
    path: 'images-detail',
    loadChildren: () => import('./pages/images-detail/images-detail.module').then(m => m.ImagesDetailPageModule)
  },
  {
    path: 'video-attaching',
    loadChildren: () => import('./pages/video-attaching/video-attaching.module').then(m => m.VideoAttachingPageModule)
  },
  {
    path: 'setting',
    loadChildren: () => import('./pages/setting/setting.module').then(m => m.SettingPageModule)
  },
  {
    path: 'signup-before',
    loadChildren: () => import('./pages/account/signup-before/signup-before.module').then(m => m.SignupBeforePageModule)
  },
  {
    path: 'new-real-time',
    loadChildren: () => import('./pages/new-real-time/new-real-time.module').then(m => m.NewRealTimePageModule)
  },
  {
    path: 'review',
    loadChildren: () => import('./pages/review/review.module').then( m => m.ReviewPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
